import React from "react";

const certificationsData = [
  {
    title: "Microsoft Certified: Fabric Analytics Engineer Associate",
    src: "/certifications/DA.png",
    link: "https://learn.microsoft.com/en-gb/users/akshaykalamkar-7178/credentials/5efebbd6af993f45",
  },
  {
    title: "Microsoft Certified: Fabric Data Engineer Associate",
    src: "/certifications/DE.png",
    link: "https://learn.microsoft.com/en-gb/users/akshaykalamkar-7178/credentials/191eff0e37629c47",
  },
  {
    title: "Google Data Analytics Professional Certificate",
    src: "/certifications/google.png",
    link: "https://www.coursera.org/account/accomplishments/specialization/certificate/VR25D2QLVPSX",
  },
  {
    title: "Extract, Transform and Load Data in Power BI",
    src: "/certifications/ETL.png",
    link: "https://www.coursera.org/account/accomplishments/certificate/XFGBA2UPBV2K",
  },
];

const Certifications = () => {
  return (
    <div className="w-full mt-12 flex justify-center">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 max-w-[1000px]">
        {certificationsData.map((cert) => (
          <div key={cert.title} className="flex flex-col items-center">
            <a
              href={cert.link}
              target="_blank"
              rel="noopener noreferrer"
              className="
                group
                w-full h-[360px]
                rounded-2xl
                p-[2px]
                bg-transparent
                hover:bg-[#b1124a]   /* Changed to dark pink */
                transition-all duration-300 ease-out
                hover:scale-[1.02]
                hover:shadow-xl
              "
            >
              <div
                className="
                  w-full h-full
                  rounded-2xl
                  bg-[#1f2226]
                  flex justify-center items-center
                  overflow-hidden
                "
              >
                <img
                  src={cert.src}
                  alt={cert.title}
                  className="w-full h-full object-contain rounded-xl"
                />
              </div>
            </a>

            <h3 className="text-sm font-semibold text-center mt-4 leading-snug text-gray-200 px-4">
              {cert.title}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Certifications;
